import styled from 'styled-components';

export const Form = styled.form`
  margin-top: 20px;
  background-color: var(--white);
  padding: 20px;
  color: #000;
`;

export const Submit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const MyTable = styled.table`
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
  background-color: #fff;

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  } 

  .verde{
    background-color: rgba(39, 174, 96,.5);
    color: #000;
  }
  
  .amarelo{
    background-color: rgba(241, 196, 15,.5);
    color: #000;
  }

  .vermelho{
    background-color: rgba(231, 76, 60,.5);
    color: #000;
  }
`;